import { render, staticRenderFns } from "./EditVisionMission.vue?vue&type=template&id=59c2255f&scoped=true&"
import script from "./EditVisionMission.vue?vue&type=script&lang=js&"
export * from "./EditVisionMission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c2255f",
  null
  
)

export default component.exports